import React, { useContext, useState } from "react";
import {
  createPaymentTransaction,
  useMakeaPaymentFetch,
} from "../../../../../hooks/useMakeaPayment";

import FullReceiptDialog from "../../../../../components/FullReceiptDialog";
import { PaymentCreateContext } from "../../../payment-addproduct/PaymentCreateContext";
import { useHistory } from "react-router-dom";
import { useLocale } from "ra-core";
import useSFAlert from "../../../../../hooks/useSFAlert";

function PaymentConfirm({ fullPaymentBeforeChange = 0 }) {
  const [state, dispatch] = useContext(PaymentCreateContext);
  const [disabled, setDisabled] = useState(false);
  const locale = useLocale();
  const history = useHistory();
  const products = state.items.map((item) => ({
    name: item.productName,
    code: item.code,
    qty: item.qty,
    price: item.chargeAmount,
  }));
  const paymentTransaction = createPaymentTransaction(state, locale);
  const [note, setNote] = useState();
  const [customTime, setCustomTime] = useState();
  const { pay, receipt } = useMakeaPaymentFetch(locale);
  const { discount } = state;
  const [alert] = useSFAlert();
  if (receipt)
    history.push({
      pathname: "/payment/success",
      state: { receipt: receipt, payment: state, paymentTransaction },
    });

  return (
    <FullReceiptDialog
      open={state.showPaymentConfirm}
      products={products}
      paymentTransaction={paymentTransaction}
      discount={discount}
      onClose={() => dispatch({ type: "HIDE_PAYMENT_CONFIRM" })}
      note={note}
      setNote={setNote}
      setCustomTime={setCustomTime}
      disabled={disabled}
      fullPaymentBeforeChange={fullPaymentBeforeChange}
      onClick={async () => {
        setDisabled(true);
        const result = await pay(note, customTime);

        if (result?.error) {
          alert("Can't proceed payment. " + JSON.stringify(result.message));
          setDisabled(false);
        }
      }}
    />
  );
}

export default PaymentConfirm;
